import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DomSanitizer, SafeHtml } from '@angular/platform-browser';

type FormatKind = 'number' | 'currency' | 'string';

@Component({
  selector: 'app-metro-kpi',
  standalone: false,
  templateUrl: './metro-kpi.component.html'
})
export class MetroKpiComponent {
  constructor(private sanitizer: DomSanitizer) {}

  @Input() title = 'Ventas Totales';
  @Input() value: number | string = 0;
  @Input() format: FormatKind = 'string';
  @Input() locale = 'es-AR';
  @Input() decimals = 0;
  @Input() currency = 'USD';
  @Input() prefix = '';
  @Input() suffix = '';
  @Input() subtext = '';
  @Input() iconSvg?: string;
  @Input() loading = false;
  @Input() highlight = false;
  @Input() clickable = false;

  @Output() pressed = new EventEmitter<void>();

  get iconSafe(): SafeHtml | null {
    return this.iconSvg ? this.sanitizer.bypassSecurityTrustHtml(this.iconSvg) : null;
  }

  onClick() {
    if (this.clickable) this.pressed.emit();
  }

  get formattedValue(): string {
    if (this.loading) return '';
    const raw = this.value;
    if (this.format === 'string') return `${this.prefix}${raw ?? ''}${this.suffix}`;
    const num = typeof raw === 'number' ? raw : Number(String(raw).replace(/[^\d.-]/g, ''));
    if (isNaN(num)) return `${this.prefix}${raw ?? ''}${this.suffix}`;
    return this.formatNumber(num);
  }

  private formatNumber(num: number): string {
    if (this.format === 'currency') {
      return `${this.prefix}${new Intl.NumberFormat(this.locale, {
        style: 'currency',
        currency: this.currency,
        minimumFractionDigits: this.decimals,
        maximumFractionDigits: this.decimals
      }).format(num)}${this.suffix}`;
    }
    return `${this.prefix}${new Intl.NumberFormat(this.locale, {
      minimumFractionDigits: this.decimals,
      maximumFractionDigits: this.decimals
    }).format(num)}${this.suffix}`;
  }
}
